"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = void 0;

var _EmptyObservable = require("./EmptyObservable");

var empty = _EmptyObservable.EmptyObservable.create;
exports.empty = empty;